<div class="profile-save-panel-wrapper">
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="divForm">
    <form [formGroup]="editUserProfileForm">
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ translation.Nombre }}</mat-label>
          <input matInput formControlName="Nombre" maxlength="20" (input)="onNombreInput($event)" />
          <mat-error *ngIf="validateFields('Nombre')">
            {{ getErrorMessage("Nombre") }}
          </mat-error>
        </mat-form-field>

        <!-- se deshabilita el campo privilegios para que no se pueda modificar desde esta pantalla -->
        <mat-form-field appearance="outline" *ngIf="false">
          <mat-label>{{ translation.Privilegios }}</mat-label>
          <input matInput formControlName="Privilegios" />
          <mat-error *ngIf="validateFields('Privilegios')">
            {{ getErrorMessage("Privilegios") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="mode === 'U'">
          <mat-label>{{ translation.idTyp }}</mat-label>
          <input matInput formControlName="idTyp" />
          <mat-error *ngIf="validateFields('idTyp')">
            {{ getErrorMessage("idTyp") }}
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ translation.Descripcion }}</mat-label>
        <textarea
          matInput
          rows="5"
          cols="60"
          formControlName="Descripcion"
          maxlength="50"
          (input)="onDescripcionInput($event)"
        ></textarea>
        <mat-error *ngIf="validateFields('Descripcion')">
          {{ getErrorMessage("Descripcion") }}
        </mat-error>
      </mat-form-field>

      <div class="centros-section" style="margin: 20px 5px 0 5px; text-align: center">
        <mat-label class="centros-section-title">{{ translation.Centros }}</mat-label>

        <customan-dual-list
          *ngIf="centrosSinAsignar"
          [source]="centrosSinAsignar"
          [(destination)]="centrosAsignados"
          key="pkId"
          display="Nombre"
          [format]="format"
          [filter]="true"
          [height]="'260px'"
        >
        </customan-dual-list>
      </div>

      <div class="permisos-section" style="margin: 20px 5px 0 5px; text-align: center">
        <mat-label class="permisos-section-title">{{ translation.Permisos || 'Permisos' }}</mat-label>

        <mat-accordion class="permisos-accordion">
          <mat-expansion-panel *ngFor="let app of permisosTree" class="permisos-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ app.NombreAplicacion }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="dual-list-wrap">
              <mat-label class="modulos-label">{{ translation.ModulosPrincipales || 'Módulos principales' }}</mat-label>
              <customan-dual-list
                class="dual-list"
                [source]="app.modulosPrincipalesTodos"
                [(destination)]="app.modulosAsignados"
                key="ModuloId"
                display="NombreModulo"
                [actionTemplate]="moduloAction"
                [format]="format"
                [filter]="true"
                [isRightMultiSelection]="false"
                [height]="'360px'"
                (emitMovedCentro)="onModulosMoved(app)"
              ></customan-dual-list>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <ng-template #moduloAction let-item>
        <button mat-raised-button color="accent" (click)="openDesgloseModuloFromItem(item)">
          {{ translation.Desglosar || translation.Desglose || 'Desglosar' }}
        </button>
      </ng-template>
    </form>
  </div>
</div>

<div
  class="tipo-usuario-permisos-overlay"
  *ngIf="tipoUsuarioPermisosModalVisible"
>
  <div
    #tipoUsuarioPermisosContainer
    class="tipo-usuario-permisos-container"
  >
    <app-tipo-usuario-permisos-dialog
      [aplicacion]="aplicacionDesglose"
      [moduloId]="moduloDesgloseId"
      [translation]="translation"
      [isNewProfile]="mode === 'I'"
      (saveRequested)="onTipoUsuarioPermisosSave()"
      (cancelRequested)="onTipoUsuarioPermisosCancel()"
    ></app-tipo-usuario-permisos-dialog>
  </div>
</div>
</div>
